import React from "react";
import { Context, Cookie, Platform, Bridge, Util, Request } from "@xt/xtbase";

const { XtContext } = Context;
const { XtAxios4, setHeader, setListenKey } = Request;

/**
 * 无 Nav / XtAuth 的页面（如移动端 beginner-guide）也需要拉取 getUserInfo。
 * 与 XtAuth 共用 isAuthing，避免重复请求。
 */
export default function UserAuthBootstrap() {
  const [appState, appDispatch] = React.useContext(XtContext);
  const { loginStatus } = appState;

  React.useEffect(() => {
    const token = (Platform.isInApp() ? Bridge.getToken() : null) || Cookie.get("token");

    if (!token) {
      if (loginStatus === 0) {
        appDispatch({ payload: { loginStatus: 2 } });
      }
      return;
    }

    setHeader({ token, Authorization: `Bearer ${token}` });
    setListenKey(token);

    if (loginStatus === 1 || XtAxios4.isAuthing) return;

    XtAxios4.isAuthing = true;
    XtAxios4.get(Util.getOrigin("www") + "/uaapi/user/user/getUserInfo", { noHandle401: true })
      .then((userInfo) => {
        appDispatch({ payload: { userInfo, loginStatus: 1 } });
      })
      .catch((err) => {
        const isUnauthorized = err?.response?.status === 401 || err?.response?.data?.code === 401;
        if (isUnauthorized) {
          Cookie.remove("token");
          setHeader({ token: "", Authorization: "" });
        }
        appDispatch({ payload: { loginStatus: 2 } });
      })
      .finally(() => {
        XtAxios4.isAuthing = false;
      });
  }, [appDispatch, loginStatus]);

  return null;
}
